import { S25ItemI } from "./S25ItemI";
import { DurationI } from "./DurationI";
import { S25WsNode } from "./S25WsNode";
import { Proto } from "./Proto";
import ISODateString = Proto.ISODateString;
import ServiceStatus = Proto.ServiceStatus;

export enum RateTypeIds {
    EventType = 1,
    Requirement,
    Location,
    Resource,
}

export interface RateScheduleI extends S25ItemI<RateTypeIds> {
    itemName?: string; //rate_name
    itemId?: number; //rate_id
    itemTypeId?: RateTypeIds; //rate_type_id,
    itemTypeName?: string;
    favorite?: Proto.CharBoolean | boolean;
    creditAcctCode?: string;
    debitAcctCode?: string;
    internalNotes?: string;
    priceSheets: PriceSheetI[];
    taxes?: any[];
    billingItems?: S25ItemI[];
    status?: ServiceStatus; //new, est, mod, del
}

export type RateSchedule = {
    credit_acct_code: string;
    debit_acct_code: string;
    favorite: Proto.CharBoolean;
    last_mod_dt: ISODateString;
    rate_id: string | number;
    rate_name: string;
    status: ServiceStatus;
    type: "Event Types" | "Requirements" | "Resource" | "Space";
    type_id: string | number;
};

export interface PriceSheetI extends S25WsNode {
    version?: number; //unique identifier
    description?: { data: string };
    rateGroupId?: number;
    rateGroupName?: string;
    startDt?: Date;
    formula?: FormulaI[];
    datepickerBean?: Date;
    status?: ServiceStatus;
}

export interface FormulaI {
    break_point?: number | string; //unique identifier
    durStart: DurationType;
    durEnd: DurationType;
    rangeType: "none" | "time" | "duration";
    expression: string;
    status: ServiceStatus;

    date?: { date: Date };
    startDt?: Date;
    effectiveDate?: Date;
    startTime?: string;
    endTime?: string;
}

export type DurationType = string | DurationI | Date;

export type RateTypeObj = {
    itemId: RateTypeIds;
    itemTypeCode: "eventTypes" | "eventRequirements" | "locations" | "resources";
    itemTypeName: "Event Types" | "Requirements" | "Locations" | "Resources";
};

export namespace RateSchedulePayload {
    export interface WrapperI {
        rate: {
            rate_schedule: RateScheduleI;
        };
    }

    export interface PayloadI extends S25WsNode {
        credit_acct_code?: string;
        debit_acct_code?: string;
        internal_notes?: string;
        rate_id: number | string;
        rate_name: string;
        rate_type_id: number | string; //TODO: create enum for itemTypeIds
        event_type?: EventTypeI[];
        resource?: ResourceI[];
        service?: ServiceI[];
        space?: SpaceI[];
        tax?: TaxI[];
        price_sheet?: PriceSheetI[];
    }

    export interface PriceSheetI extends S25WsNode {
        rate_group_id: number;
        rate_group_name: string;
        version?: number;
        effective_date?: string;
        description?: string;
        rate_formula?: FormulaI[];

        [key: string]: any;
    }

    /**
     *     min/max use 3 segment string/number to store  none/specific times/specific duration
     *     none: min="0.0.0" and max = 1000.0.0 (or min or max is undefined/empty string)
     *     specific times: starts with "2000." ex: 2000.17.0 = 5pm (flag.hours.minutes)
     *     specific duration: d.h.m
     */
    export interface FormulaI extends S25WsNode {
        min: string;
        max: string;
        break_point: string;
        formula: string;
    }

    export interface ResourceI extends S25WsNode {
        resource_id: number;
        resource_name: string;
    }

    export interface SpaceI extends S25WsNode {
        space_id: number;
        space_name: string;
    }

    export interface ServiceI extends S25WsNode {
        service_id: number;
        service_name: string;
    }

    export interface EventTypeI extends S25WsNode {
        type_id: number | string;
        type_name: string;
    }

    export interface TaxI extends S25WsNode {
        tax_id: number;
        tax_name: string;
    }
}
